import { Action, createReducer, on } from '@ngrx/store';
import * as LayoutActions from './layout.actions';
import { cloneDeep } from 'lodash';
export const layoutFeatureKey = 'layout';

export interface LayoutState {
  isLoading: boolean;
  message: string[];
}

const initialLayoutState: LayoutState = {
  isLoading: false,
  message: [],
};

export const layoutReducer = createReducer(
  initialLayoutState,
  on(LayoutActions.StartLoading, (state = initialLayoutState, action) => {
    let msg = 'Please wait...';
    if (action.message) {
      msg = action.message;
    }
    const message = [...state.message, msg];
    return {
      ...state,
      isLoading: true,
      message,
    };
  }),
  on(LayoutActions.StopLoading, (state = initialLayoutState, action) => {
    const message = cloneDeep(state.message);
    message.shift();
    const isLoading = message.length > 0;
    return {
      ...state,
      isLoading,
      message,
    };
  }),
);
